import React, { useState, useEffect } from "react";
import ListLayout from "../../../../../partials/content/ListLayout";
import SoBasicInfo from "./soBasicInfo";
import SoGoodsIssued from "./soGoodsIssued";
import SoPrintOut from "./soPrintOut";
import ContentLayout from "../../../../../partials/content/ContentLayout";
import { getSalesOrder } from "../../../../../services/sales/salesOrderService";
import { PageSubHeader } from "../../../../../../provider/PageDataProvider";
import Notes from "../../../common/notes";
import Attachments from "../../../common/attachments";
import DocRefInvoices from "../../../finance/invoice/docRefInvoices";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";
import SalesReturnList from "../../sales-return/salesReturnList";
import SoDeliveryOrder from "./SoDeliveryOrder";
const SalesOrderDetail = ({ match, history }) => {
  const { reload } = useGlobalData();
  const salesOrderID = match.params.salesOrderID;
  const [salesOrder, setSalesOrder] = useState({ ID: 0 });
  const [approvalProcess, setApprovalProcess] = useState([]);
  const [approvalSteps, setApprovalSteps] = useState([]);
  const [approvalActiveStep, setApprovalActiveStep] = useState(0);
  const [component, setComponent] = useState(null);
  const [headerTitle, setHeaderTitle] = useState("Basic Info");
  const [listMenu, setListMenu] = useState([
    {
      key: "basicInfo",
      label: "Basic Info",
      icon: "fas fa-th-large",
    },
    {
      key: "deliveryOrder",
      label: "Delivery Order",
      icon: "fas fa-shipping-fast",
    },
    {
      key: "salesReturn",
      label: "Sales Return",
      icon: "fas fa-truck-loading",
    },
    {
      key: "invoices",
      label: "A/R Invoices",
      icon: "fas fa-file-invoice-dollar",
    },
    {
      key: "attachments",
      label: "Attachments",
      icon: "fas fa-paperclip",
    },
    {
      key: "notes",
      label: "Notes",
      icon: "fas fa-sticky-note",
    },
    {
      key: "printOut",
      label: "PrintOut",
      icon: "fas fa-print",
    },
  ]);

  const defaultSelected = "basicInfo";

  useEffect(() => {
    getSalesOrderData();
  }, [salesOrderID, reload]);

  const actionButtons = [
    {
      title: "",
      color: "label-brand",
      icon: "fas fa-backward",
      onClick: () => {
        history.push("/sales/sales-order/sales-order-list");
      },
    },
  ];
  if (
    salesOrder.edit &&
    (salesOrder.approvalProcessID === 0 ||
      salesOrder.approvalProcess.statusID === 2 ||
      salesOrder.approvalProcess.statusID === 3) &&
    salesOrder.invoiceStatus === 1 &&
    salesOrder.giStatus === 1
  ) {
    actionButtons.push({
      title: "Edit Sales Order",
      color: "primary",
      icon: "fas fa-edit",
      onClick: () => {
        history.push(`/sales/sales-order/edit-sales-order/${salesOrderID}`);
      },
    });
  }

  return (
    <React.Fragment>
      <PageSubHeader
        title={headerTitle ? headerTitle : "Basic Info"}
        breadcrumbs={[
          { page: "/menu", title: "Menu", active: false },
          {
            page: "/sales/sales-order/sales-order-list",
            title: "Sales Orders",
            active: false,
          },
          {
            page: "/sales/sales-order/sales-order-detail/" + salesOrderID,
            title: "Sales order ID " + salesOrder.salesOrderCode,
            active: true,
          },
        ]}
        actionButtons={actionButtons}
      />
      <ContentLayout>
        <ListLayout
          component={component}
          listMenu={listMenu}
          onSelectItem={(key) => {
            let selectedComponent;
            switch (key) {
              case "basicInfo":
                selectedComponent = (
                  <SoBasicInfo
                    salesOrderImp={salesOrder}
                    approvalProcessImp={approvalProcess}
                    approvalStepsImp={approvalSteps}
                    approvalActiveStepImp={approvalActiveStep}
                  />
                );
                setHeaderTitle("Basic Info");
                break;
              case "salesReturn":
                selectedComponent = (
                  <SalesReturnList
                    salesOrderID={salesOrder.ID}
                    salesOrder={salesOrder}
                  />
                );
                setHeaderTitle("Goods Issued");
                break;
              case "deliveryOrder":
                selectedComponent = (
                  <SoDeliveryOrder salesOrderID={salesOrder.ID} />
                );
                setHeaderTitle("Goods Issued");
                break;
              case "goodsIssued":
                selectedComponent = <SoGoodsIssued soID={salesOrder.ID} />;
                setHeaderTitle("Goods Issued");
                break;
              case "invoices":
                selectedComponent = (
                  <DocRefInvoices
                    docRef="1"
                    docID={salesOrder.ID}
                    history={history}
                  />
                );
                setHeaderTitle("A/R Invoices");
                break;
              case "attachments":
                selectedComponent = (
                  <Attachments docType="SORD" docID={salesOrder.ID} />
                );
                setHeaderTitle("Attachments");
                break;
              case "notes":
                selectedComponent = (
                  <Notes docType="SORD" docID={salesOrder.ID} />
                );
                setHeaderTitle("Notes");
                break;
              case "printOut":
                selectedComponent = <SoPrintOut soData={salesOrder} />;
                setHeaderTitle("Print Out");
                break;
              default:
                selectedComponent = (
                  <SoBasicInfo
                    salesOrderImp={salesOrder}
                    approvalProcessImp={approvalProcess}
                    approvalStepsImp={approvalSteps}
                    approvalActiveStepImp={approvalActiveStep}
                  />
                );
                setHeaderTitle("Basic Info");
                break;
            }
            setComponent(selectedComponent);
          }}
          defaultSelected={defaultSelected}
        />
      </ContentLayout>
    </React.Fragment>
  );

  async function getSalesOrderData() {
    const response = await getSalesOrder(salesOrderID);
    const { data } = response.data;
    const componentTmp = (
      <SoBasicInfo
        salesOrderImp={data.salesOrder}
        approvalProcessImp={data.approvalProcess}
        approvalStepsImp={
          data.salesOrder.approvalProcess.approval.approvalValue
        }
        approvalActiveStepImp={data.salesOrder.approvalProcess.level}
      />
    );
    setSalesOrder(data.salesOrder);
    setApprovalProcess(data.approvalProcess);
    setApprovalSteps(data.salesOrder.approvalProcess.approval.approvalValue);
    setApprovalActiveStep(data.salesOrder.approvalProcess.level);
    setComponent(componentTmp);
  }
};

export default SalesOrderDetail;
